import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const ADD_PAYSLIP = gql`
  mutation AddPayslip(
    $payslipFileUuid: ID,
    $consultantUuid: ID!,
    $period: Date!,
    $currency: String!,
    $grossSalary: Float!,
    $netSalary: Float!,
    $taxes: Float!,
    $employerContributions: Float!,
    $employeeContributions: Float!,
    $comment: String,
    $bonus: Boolean!,
    $paymentDate: Date
  ) {
    addPayslip(newPayslip: {
      payslipFileUuid: $payslipFileUuid,
      consultantUuid: $consultantUuid,
      period: $period,
      currency: $currency,
      grossSalary: $grossSalary,
      netSalary: $netSalary,
      taxes: $taxes,
      employerContributions: $employerContributions,
      employeeContributions: $employeeContributions,
      comment: $comment,
      bonus: $bonus,
      paymentDate: $paymentDate
    }) {
      uuid
      payslipFileUuid
      year
      month
      currency
      grossSalary
      netSalary
      taxes
      employerContributions
      employeeContributions
      comment
      bonus
      paymentDate
    }
  }
`;


export const useAddPayslip = () => {
  const [addPayslip, { loading, error, data }] = useMutation(ADD_PAYSLIP);

  return { addPayslip, loading, error, data };
};
